// src/universal/minimalism/domainPalette.ts
var financePalette = {
  must: "#ef4444",
  // red-500
  nice: "#3b82f6",
  // blue-500
  waste: "#f59e0b",
  // amber-500
  total: "#8b5cf6",
  // violet-500
  default: "#6b7280"
  // gray-500
};
var getFinanceColor = (theme, category) => {
  var _a;
  return (_a = theme.palette.finance[category]) != null ? _a : theme.palette.finance.default;
};

export { financePalette, getFinanceColor };
//# sourceMappingURL=chunk-AEFY5JL4.mjs.map
//# sourceMappingURL=chunk-AEFY5JL4.mjs.map